/* eslint class-methods-use-this: "off", react/prefer-stateless-function: "off" */

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "underscore";

import Input from "@exovera/input";
import vars from "@exovera/narrative-tracker-variables";
import RoundSpinner from "genericComponents/RoundSpinner";

import {
	backToLogin,
	updateLoginVerificationCode,
	resetPassword,
	updateLoginNewPassword,
} from "actions/login.js";

import { isPasswordValid } from "lib/loginHelpers.js";

class CreateNewPassword extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			focusCode: false,
			codeError: false,
			passwordValid: false, // enables second password field
		};

		this.validateForm = this.validateForm.bind(this);
		this.validatePassword = this.validatePassword.bind(this);
	}
	componentDidMount() {
		this.setState({ focusCode: true }); // Doesn't work in the contructor
	}

	// just checking for code field. Password has already been validated at this point
	validateForm(event) {
		event.preventDefault();
		const { props, state } = this;
		if (!props.validationInProgress && props.loginInputVerificationCode && state.passwordValid) {
			this.setState({ codeError: false });
			props.dispatch(resetPassword(props.loginInputVerificationCode, props.loginInputNewPassword));
		} else if (!props.validationInProgress && !props.loginInputVerificationCode) {
			this.setState({ codeError: true, focusCode: true });
		}
	}

	// password must be 8 characters and include uppercase, lowercase, and a number
	validatePassword(password) {
		const { props } = this;
		const passwordValid = isPasswordValid(password);

		this.setState({ passwordValid });
		props.dispatch(updateLoginNewPassword(password));
	}
	render() {
		const { props, state } = this;
		// console.log("ForgotPassword", props);
		const loginClass = classnames("login", { error: props.loginError });
		const codeErrorClass = classnames("login__error", { visible: state.codeError });
		const buttonBoxClass = classnames("login__submit-box", { spinner: props.validationInProgress });
		const submitClass = classnames("login__submit", { disabled: !state.passwordValid });
		const checkmarkClass = classnames("login__password-valid-checkmark", {
			visible: state.passwordValid,
		});

		return (
			<div className={loginClass}>
				<div className="login__box">
					<p className="login__top-error">{props.loginErrorText}</p>

					<div className="login__return" onClick={() => props.dispatch(backToLogin())}>
						Return to login
					</div>

					<h1 className="login__header">Recover Password</h1>
					<p className="login__sub-header">{props.codeDeliveryMessage}</p>

					<div className="login__input-box">
						<label htmlFor="login-new-password-code" className="login__input-label">
							Code
						</label>
						<Input
							acceptBtnFunction={this.validateForm}
							focus={state.focusCode} // can set focus by passing a prop
							label={false}
							id="login-new-password-code"
							// note: PropTypes.func, // appears below input. Expects a React component
							onChange={(value) => props.dispatch(updateLoginVerificationCode(value))}
							placeholder=""
							// "dark", 'light', 'inline'. Themes show a box, none is inline. Add ' search' to any
							theme={props.darkUI ? "dark" : "blueGrey"}
							type="number"
							value={props.loginInputVerificationCode}
						/>
						<p className={codeErrorClass}>
							Please enter the verification code that was emailed to you.
						</p>
					</div>

					<div className="login__input-box">
						<label htmlFor="login-forgot-password-new" className="login__input-label">
							New Password
						</label>
						<Input
							acceptBtnFunction={this.validateForm}
							focus={state.focusEmail} // can set focus by passing a prop
							label={false}
							id="login-new-password-new"
							onChange={(text) => this.validatePassword(text)}
							placeholder=""
							// "dark", 'light', 'inline'. Themes show a box, none is inline. Add ' search' to any
							theme={props.darkUI ? "dark" : "blueGrey"}
							type="password"
							value={props.loginInputNewPassword}
						/>
						<div className={checkmarkClass} />
						<p className="login__instructions">
							Password must be at least eight characters, including one uppercase character, one
							lowercase character, and a number.
						</p>
					</div>

					<div className={buttonBoxClass}>
						<div className="login__spinner">
							<RoundSpinner scale={0.6} color={vars.cerulean_2} />
						</div>

						<button
							type="submit"
							className={submitClass}
							aria-disabled={!state.passwordValid}
							onClick={this.validateForm}
						>
							<span className="login__submit--text">Send Code</span>
						</button>
					</div>
				</div>
			</div>
		);
	}
}

CreateNewPassword.propTypes = {
	codeDeliveryMessage: PropTypes.string.isRequired,
	dispatch: PropTypes.func.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,
	loginInputVerificationCode: PropTypes.string.isRequired,
	loginInputNewPassword: PropTypes.string.isRequired,
};

export default CreateNewPassword;
